export const convertToTimeFormat = (time: number) =>
  time <= 9 ? `0${time}` : time;

export const flashSaleColor = 'rgba(32, 154, 214, 1)';
